<template>
  <div
    :class="[
      'post_gallery_sidebar',
      darkClass && 'section' in darkClass ? darkClass.section : '',
    ]"
  >
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item" @click.prevent="selectGalleryTab('trendy')">
        <a
          :class="['nav-link', selectedGallery === 'trendy' ? 'active' : '']"
          data-toggle="pill"
          role="tab"
          aria-controls="pills-home"
          aria-selected="true">热门趋势</a>
      </li>

      <li class="nav-item" @click.prevent="selectGalleryTab('latest')">
        <a
          :class="['nav-link', selectedGallery === 'latest' ? 'active' : '']"
          data-toggle="pill"
          href="#pills-profile"
          role="tab"
          aria-controls="pills-profile"
          aria-selected="false">最新</a>
      </li>

      <li class="nav-item" @click.prevent="selectGalleryTab('popular')">
        <a
          :class="['nav-link', selectedGallery === 'popular' ? 'active' : '']"
          class="nav-link"
          data-toggle="pill"
          href="#pills-contact"
          role="tab"
          aria-controls="pills-contact"
          aria-selected="false">精选</a>
      </li>
    </ul>

    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'trendy' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div class="post_gallery_items" v-if="datas && datas.length > 0">
          <template v-for="(small, index) in datas.slice().sort((a, b) => b.view - a.view).slice(0, 4)">
            <row-card
              :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
              :category="true"
              :datas="small"
              :key="index"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'latest' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div v-if="datas && datas.length > 0" class="post_gallery_items">
          <template v-for="(small, index) in datas.slice(0,4)">
            <row-card :category="true" :datas="small" :key="index" />
          </template>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'popular' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div v-if="datas && datas.length > 0" class="post_gallery_items">
          <template v-for="(small, index) in datas.filter(item => item.recommend === true).slice(0,4)">
            <row-card :category="true" :datas="small" :key="index" />
          </template>
        </div>
      </div>
    </div>
    
    
    <signup-style-two v-if="signup" />
   
    
    <div v-if="trendingBigPost" class="trending-sidebar mt-40">
      <div class="section-title">
        <h3 class="title">热点</h3>
      </div>
      <div class="trending-sidebar-slider position-relative">
        <span
          @click.prevent="trendingNewsPrev"
          class="prev slick-arrow"
          style="display: block"
          ><i class="fal fa-angle-left"></i
        ></span>
        <slider v-if="datas.length > 0" :settings="trendingNews" ref="trendingNews">
          <template v-for="(data, index) in datas.slice().sort((a, b) => b.view - a.view).slice(0, 8)">
            <divide-card 
              stype="col" 
              :datas="data" 
              :key="index"
              v-if="data"
            />
          </template>
        </slider>
        <span
          @click.prevent="trendingNewsNext"
          class="next slick-arrow"
          style="display: block"
          ><i class="fal fa-angle-right"></i
        ></span>
      </div>
    </div>

    <!--
    <div v-if="trendingShortPost" class="trending-news-post-items">
      <div class="gallery_item">
        <div class="gallery_item_thumb">
          <img src="@/assets/images/gallery-1.jpg" alt="gallery" />
          <div class="icon"><i class="fas fa-bolt"></i></div>
        </div>
        <div class="gallery_item_content">
          <div class="post-meta">
            <div class="meta-categories">
              <a href="#">TECHNOLOGY</a>
            </div>
            <div class="meta-date">
              <span>March 26, 2020</span>
            </div>
          </div>
          <h4 class="title">
            <a href="#">Nancy zhang a chinese busy woman and dhaka</a>
          </h4>
        </div>
      </div>
      <div class="gallery_item">
        <div class="gallery_item_thumb">
          <img src="@/assets/images/gallery-2.jpg" alt="gallery" />
          <div class="icon"><i class="fas fa-bolt"></i></div>
        </div>
        <div class="gallery_item_content">
          <div class="post-meta">
            <div class="meta-categories">
              <a href="#">TECHNOLOGY</a>
            </div>
            <div class="meta-date">
              <span>March 26, 2020</span>
            </div>
          </div>
          <h4 class="title">
            <a href="#">The billionaire Philan thropist read to learn</a>
          </h4>
        </div>
      </div>
      <div class="gallery_item">
        <div class="gallery_item_thumb">
          <img src="@/assets/images/gallery-3.jpg" alt="gallery" />
          <div class="icon"><i class="fas fa-bolt"></i></div>
        </div>
        <div class="gallery_item_content">
          <div class="post-meta">
            <div class="meta-categories">
              <a href="#">TECHNOLOGY</a>
            </div>
            <div class="meta-date">
              <span>March 26, 2020</span>
            </div>
          </div>
          <h4 class="title">
            <a href="#">Cheap smartphone sensor could help you old food safe</a>
          </h4>
        </div>
      </div>
    </div>
    -->
    
    <div v-if="ad" class="sidebar-add pt-35">
      <template v-if="adRight && adRight.id">
        <img 
          class="cursor-pointer"
          :src="adRight.coverurl" 
          alt="ad"
          @click="handleClick(adRight)"
        />
      </template>
    </div>
    
    <!--
    <share-post v-if="sharePost" class="mt-40" />
    -->
  </div>
</template>

<script>
// import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import Slider from "../../Helpers/Slider.vue";
// import SharePost from "../../Home/SharePost.vue";
import DivideCard from "../Cards/DivideCard.vue";
import RowCard from "../Cards/RowCard.vue";
import SignupStyleTwo from "../Signup/SignupStyleTwo.vue";

import { getAds, clickPlacement } from '@/api/placement';
import config from '@/config';

export default {
  components: { 
    RowCard, 
    SignupStyleTwo, 
    DivideCard, 
    Slider, 
    // SharePost 
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    darkClass: {
      type: Object,
      default: () => {},
    },
    signup: {
      type: Boolean,
      default: true,
    },
    trendingBigPost: {
      type: Boolean,
      default: true,
    },
    trendingShortPost: {
      type: Boolean,
      default: true,
    },
    ad: {
      type: Boolean,
      default: true,
    },
    sharePost: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selectedGallery: "trendy",
    trendingNews: {
      autoplay: true,
      slideToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      dots: false,
    },
    isLoading: true,
    adRight:[],
  }),
  created() {
    this.fetchAdsRight();
  },
  watch: {
    datas: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // 当 datas 有数据时，将 isLoading 设置为 false
          this.isLoading = false;
        }
      },
      immediate: true, // 组件创建时立即执行一次
      deep: true // 深度监听数组变化
    }
  },
  methods: {
    selectGalleryTab(value) {
      this.selectedGallery = value;
    },
    trendingNewsPrev() {
      this.$refs.trendingNews.prev();
    },
    trendingNewsNext() {
      this.$refs.trendingNews.next();
    },
    async fetchAdsRight(){
      try {
        const adsResponse = await getAds(config.AD_BOTTOMRIGHTSQUAREFIXEDBANNER);
        this.adRight = adsResponse.data?.[0] || null; 
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }      
    },
    handleClick() {
      if (this.datas && this.datas.link && this.datas.id) {
        const url = clickPlacement(this.datas.id, this.datas);
        window.open(url, '_blank');
      }
    }
  },
  setup() {
    // const route = useRoute();

    // // 监听路由变化
    // onBeforeRouteUpdate((to, from) => {
    //   // 在这里添加重新加载数据的逻辑
    //   console.log('路由更新，重新加载数据', to, from);
    //   // 调用重新获取数据的方法
    //   // fetchData(); 
    // });

    return {
      // route
    };
  }
};
</script>

<style></style>
